// extracted by mini-css-extract-plugin
export default {"code":"dd"};